const m03Section = {
  id: 'm03',
  name: '2027ScoresheetM03Sub1Label',
  fields: [
    {
      scoring: '2027ScoresheetM03Sub2Label',
      id: 'm03_scoring_1',
      options: [
          {
              description: 'noLabel',
              value: false
          },
          {
              description: 'yesLabel',
              value: true
          },
      ]
    },
    {
        scoring: '2027ScoresheetM03Sub3Label',
        id: 'm03_scoring_2',
        options: [
            {
                description: 'noLabel',
                value: false
            },
            {
                description: 'yesLabel',
                value: true
            },
        ]
    },
  ]
}

export default m03Section;